import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import sleighIcon from '../../assets/images/icons/sleigh.webp';
import sleighWebIcon from '../../assets/images/icons/sleigh-web.webp';
import yandexKitLogo from '../../assets/images/logos/yandex-kit.webp';
import giftIcon from '../../assets/images/logos/gift.webp';
import { useUIText } from '../../hooks/useConfig';
import { useAnalytics } from '../../hooks/useAnalytics';
import { triggerHaptic } from '../../utils/telegramActions';
import { Typo } from '../../utils/typo';
import './Welcome.scss';

function Welcome() {
    const navigate = useNavigate();
    const UI_TEXT = useUIText();
    const { trackEvent } = useAnalytics();

    // Определяем платформу через Telegram данные
    const getPlatform = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const platformFromUrl = urlParams.get('test_platform');
        return platformFromUrl || window.Telegram?.WebApp?.platform;
    };

    const isDesktop = () => {
        const platform = getPlatform();
        return platform !== 'android' && platform !== 'ios';
    };

    useEffect(() => {
        trackEvent('view_welcome');
    }, [trackEvent]);

    const handleStart = () => {
        triggerHaptic('medium');
        trackEvent('click_start');
        navigate('/letter');
    };

    return (
        <div className="welcome-container">
            <div className="welcome-content">
                <div className="welcome-logo">
                    <img
                        src={yandexKitLogo}
                        alt="Yandex Kit"
                        className="yandex-kit-logo"
                        width={130}
                        height={24}
                    />
                </div>
                <div className="welcome-main-text">
                    <div className="text-line">
                        <Typo>{UI_TEXT.WELCOME?.TITLE_LINE_1}</Typo>
                    </div>
                    <div className="text-line">
                        <Typo>{UI_TEXT.WELCOME?.TITLE_LINE_2_PREFIX}</Typo>{' '}
                        <img src={giftIcon} alt="Gift" className="gift-icon" />{' '}
                        <Typo>{UI_TEXT.WELCOME?.TITLE_LINE_2_SUFFIX}</Typo>
                    </div>
                    <div className="text-line">
                        <Typo>{UI_TEXT.WELCOME?.TITLE_LINE_3}</Typo>
                    </div>
                </div>
                <div 
                    className="welcome-description"
                    dangerouslySetInnerHTML={{ __html: UI_TEXT.WELCOME?.DESCRIPTION || '' }}
                />
            </div>

            <div className="welcome-footer">
                <img src={isDesktop() ? sleighWebIcon : sleighIcon} alt="Sleigh" className="sleigh-icon" />
                <Button className="write-letter-btn" onClick={handleStart}>
                    {UI_TEXT.WELCOME?.BUTTON}
                </Button>
            </div>
        </div>
    );
}

export default Welcome;
